import React from "react"
import { Link } from "./router"

export function Button({ children, variant = "primary", className = "", ...props }) {
  return <button className={`button button--${variant} ${className}`} {...props}>{children}</button>
}

export function Card({ children, className = "" }) {
  return <section className={`card ${className}`}>{children}</section>
}

export function Badge({ children, tone = "neutral" }) {
  return <span className={`badge badge--${tone}`}>{children}</span>
}

export function EmptyState({ icon: Icon, title, copy, action }) {
  return (
    <div className="empty-state">
      {Icon ? <span className="empty-state__icon"><Icon size={24} /></span> : null}
      <h3>{title}</h3>
      <p>{copy}</p>
      {action}
    </div>
  )
}

export function PageHeader({ eyebrow, title, copy, actions }) {
  return (
    <header className="page-header">
      <div>
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <h1>{title}</h1>
        {copy ? <p>{copy}</p> : null}
      </div>
      {actions ? <div className="page-header__actions">{actions}</div> : null}
    </header>
  )
}

export function TeamMark({ team, size = "md" }) {
  const hasLogo = Boolean(team.logo_url)

  return (
    <span
      className={`team-mark team-mark--${size}${hasLogo ? " team-mark--image" : ""}`}
      style={{ background: hasLogo ? "white" : team.primary_color }}
    >
      {hasLogo ? <img src={team.logo_url} alt={`${team.name} logo`} /> : team.name.slice(0, 2).toUpperCase()}
    </span>
  )
}

export function EventRow({ event }) {
  const date = new Date(event.game_date || event.practice_date)
  const isGame = Boolean(event.game_date)
  const href = isGame ? `/games/${event.id}` : `/practices/${event.id}`
  return (
    <Link className="event-row" to={href}>
      <span className="event-date"><strong>{date.toLocaleDateString([], { day: "numeric" })}</strong>{date.toLocaleDateString([], { month: "short" })}</span>
      <span className="event-row__body"><strong>{isGame ? `vs ${event.opponent}` : "Team practice"}</strong><small>{date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}{event.location ? ` · ${event.location}` : ""}</small></span>
      <span aria-hidden="true">→</span>
    </Link>
  )
}

export function LoadingScreen() {
  return <div className="loading"><span className="loading__ball">⚾</span><p>Loading your clubhouse…</p></div>
}

export function ErrorNotice({ error }) {
  return error ? <div className="notice notice--error">{error.message || error}</div> : null
}
